import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import Select from '../../../../../components/Select';
import { Glyphicon, Tabs, Tab } from 'react-bootstrap';
import TreeView from 'react-treeview';
import 'react-treeview/react-treeview.css';
import Spinner from '../../../../../components/Spinner/index';
import {
    fetchAllClientInformationData,
    fetchClientInformationData
} from '../../../../../services/redux/employee/clientInformation/actions';
import {
    fetchTrustByClient,
    fetchTrustData,
    fetchTrustFilings,
    fetchTrustHistory,
    handleEditTrustVisibility,
    handleViewTrustVisibility,
    clearTrustsList
} from '../../../../../services/redux/employee/trust/actions';
import {
    fetchProspectusByClient,
    fetchProspectusData,
    fetchProspectusFilings,
    fetchProspectusHistory,
    handleEditProspectusVisibility,
    handleViewProspectusVisibility,
    clearProspectusesList
} from '../../../../../services/redux/employee/prospectus/actions';
import {
    fetchPortfolioByTrust,
    fetchPortfolioData,
    fetchPortfolioFilings,
    fetchPortfolioHistory,
    handleEditPortfolioVisibility,
    handleViewPortfolioVisibility,
    clearPortfoliosList,
    fetchPortfolioById
} from '../../../../../services/redux/employee/portfolio/actions';
import {
    fetchClassesByPortfolio,
    fetchClassData,
    fetchClassFilings,
    fetchClassHistory,
    handleEditClassVisibility,
    handleViewClassVisibility,
    clearClassesList,
    fetchClassById
} from '../../../../../services/redux/employee/classes/actions';

import EditTrust from './EditTrust/index';
import ViewTrust from './ViewTrust/index';
import EditPortfolio from './EditPortfolio/index';
import ViewPortfolio from './ViewPortfolio/index';
import EditClass from './EditClass/index';
import ViewClass from './ViewClass/index';
import EditProspectus from './EditProspectus/index';
import ViewProspectus from './ViewProspectus/index';

class ClientDetails extends Component {
    constructor(props) {
        super(props);
        this.state = {
            selectedClientOption: null,
            clientOptions: [],
            trustOptions: [],
            activeTabKey: 1
        };
    }
    componentDidMount() {
        let {
            fetchAllClientInformationData,
            fetchClientInformationData,
            fetchTrustByClient,
            fetchProspectusByClient,
            portfolio,
            user,
            roleName,
            location
        } = this.props;
        if (roleName === 'Administrator') {
            fetchAllClientInformationData();
        } else if (roleName === 'User') {
            fetchClientInformationData(user.clientId).then(response => {
                if (response && response.clientId) {
                    this.setState({
                        selectedClientOption: {
                            clientId: response.clientId,
                            name: response.name
                        }
                    });
                    fetchTrustByClient(user.clientId);
                    fetchProspectusByClient(user.clientId);
                }
            });
        }

        if (location.view) {
            if (location.view === 'editClass') {
                this.onEditClick(
                    'class',
                    location.classId,
                    portfolio.portfolios,
                    true
                );
            } else {
                this.onEditClick(
                    'class',
                    location.classId,
                    portfolio.portfolios,
                    false
                );
            }
        }

        if (!location.from) {
            this.clearComponent();
        }

        /*if (location.from) {
            if (location.from !== '/filing-details') {
                this.clearComponent();
            }
            if (location.from === '/quick-filing-request') {
                if (location.view === 'editClass') {
                    this.onEditClick(
                        'class',
                        location.classId,
                        portfolio.portfolios,
                        true
                    );
                } else {
                    this.onEditClick(
                        'class',
                        location.classId,
                        portfolio.portfolios,
                        false
                    );
                }
            }
        }*/
    }

    clearComponent = () => {
        let {
            clearTrustsList,
            clearProspectusesList,
            clearPortfoliosList,
            clearClassesList
        } = this.props;
        clearTrustsList();
        clearProspectusesList();
        clearPortfoliosList();
        clearClassesList();
        this.hideAllPageVisibility();
    };

    componentWillReceiveProps(props) {
        if (props.trust.trusts !== this.props.trust.trusts) {
            this.setState({
                trustOptions: []
            });
            if (props.trust.trusts) {
                props.trust.trusts.forEach(trust => {
                    this.setState(prevState => ({
                        trustOptions: [
                            ...prevState.trustOptions,
                            {
                                trustId: trust.trustId,
                                name: trust.name,
                                edgarCik: trust.edgarCik
                            }
                        ]
                    }));
                });
            }
        }
        if (props.portfolio.portfolios !== this.props.portfolio.portfolios) {
            if (props.portfolio.portfolios) {
                let portfolios = [];
                props.portfolio.portfolios.forEach(portfolio => {
                    portfolios.push({
                        portfolioId: portfolio.portfolioId,
                        name: portfolio.name,
                        edgarSeriesId: portfolio.edgarSeriesId
                    });
                });
                let obj = this.state.trustOptions;
                obj.map(item => {
                    if (item.trustId === props.portfolio.trustId) {
                        item['portfolios'] = portfolios;
                        return item;
                    } else {
                        this.handleCollapse('trust', item.trustId, false);
                    }
                    return item;
                });
                this.setState({
                    trustOptions: obj
                });
            }
        }
        if (props.classes.classes !== this.props.classes.classes) {
            if (props.classes.classes) {
                let classes = [];
                props.classes.classes.forEach(c => {
                    classes.push({
                        classId: c.classId,
                        name: c.name,
                        clientCode: c.clientCode,
                        tickerSymbol: c.tickerSymbol,
                        cusip: c.cusip
                    });
                });
                let obj = this.state.trustOptions;
                obj.map(item => {
                    if (item.hasOwnProperty('portfolios')) {
                        item.portfolios.map(i => {
                            if (i.portfolioId === props.classes.portfolioId) {
                                i['classes'] = classes;
                                return i;
                            } else {
                                this.handleCollapse(
                                    'portfolio',
                                    item.trustId + '|' + i.portfolioId,
                                    false
                                );
                            }
                            return i;
                        });
                    }
                    return item;
                });
                this.setState({
                    trustOptions: obj
                });
            }
        }
    }
    handleClientChange = (name, selectedClientOption) => {
        let { fetchTrustByClient, fetchProspectusByClient } = this.props;
        this.setState({ selectedClientOption });
        this.hideAllPageVisibility();
        if (selectedClientOption) {
            fetchTrustByClient(selectedClientOption.clientId);
            fetchProspectusByClient(selectedClientOption.clientId);
        } else {
            this.setState({
                trustOptions: []
            });
        }
    };
    handleCollapse = (type, key, collapseState) => {
        if (collapseState === false) {
            this.setState({
                [key]: true
            });
        } else {
            // true and undefined
            if (type === 'trust') {
                this.props.fetchPortfolioByTrust(key);
            } else {
                this.props.fetchClassesByPortfolio(
                    parseInt(key.split('|')[1], 10)
                );
            }
            this.setState({
                [key]: false
            });
        }
    };
    onEditClick(type, id, parent = null, isEditPage = true) {
        let {
            fetchTrustData,
            fetchTrustFilings,
            fetchTrustHistory,
            fetchProspectusData,
            fetchProspectusFilings,
            fetchProspectusHistory,
            fetchPortfolioData,
            fetchPortfolioFilings,
            fetchPortfolioHistory,
            fetchClassData,
            fetchClassFilings,
            fetchClassHistory,
            handleEditTrustVisibility,
            handleViewTrustVisibility,
            handleEditPortfolioVisibility,
            handleViewPortfolioVisibility,
            handleEditClassVisibility,
            handleViewClassVisibility,
            handleEditProspectusVisibility,
            handleViewProspectusVisibility
        } = this.props;
        if (type === 'trust') {
            fetchTrustData(id);
            fetchTrustFilings(id);
            fetchTrustHistory(id);
            this.hideAllPageVisibility();
            isEditPage
                ? handleEditTrustVisibility(true)
                : handleViewTrustVisibility(true);
        } else if (type === 'prospectus') {
            fetchProspectusData(id);
            fetchProspectusFilings(id);
            fetchProspectusHistory(id);
            this.hideAllPageVisibility();
            isEditPage
                ? handleEditProspectusVisibility(true)
                : handleViewProspectusVisibility(true);
        } else if (type === 'portfolio') {
            let parentTrusts = parent.map(i => ({
                name: i.name,
                trustId: i.trustId
            }));
            fetchPortfolioData(id, parentTrusts);
            fetchPortfolioFilings(id);
            fetchPortfolioHistory(id);
            this.hideAllPageVisibility();
            isEditPage
                ? handleEditPortfolioVisibility(true)
                : handleViewPortfolioVisibility(true);
        } else if (type === 'class') {
            let parentPortfolios = parent.map(i => ({
                name: i.name,
                portfolioId: i.portfolioId
            }));
            fetchClassData(id, parentPortfolios);
            fetchClassFilings(id);
            fetchClassHistory(id);
            this.hideAllPageVisibility();
            isEditPage
                ? handleEditClassVisibility(true)
                : handleViewClassVisibility(true);
        }
    }
    hideAllPageVisibility = () => {
        this.props.handleEditTrustVisibility(false);
        this.props.handleViewTrustVisibility(false);
        this.props.handleEditPortfolioVisibility(false);
        this.props.handleViewPortfolioVisibility(false);
        this.props.handleEditClassVisibility(false);
        this.props.handleViewClassVisibility(false);
        this.props.handleEditProspectusVisibility(false);
        this.props.handleViewProspectusVisibility(false);
    };
    handleTabSelect = key => {
        this.setState({
            activeTabKey: key
        });
    };
    render() {
        let { selectedClientOption, trustOptions } = this.state;
        let {
            clientInformation,
            trust,
            portfolio,
            classes,
            prospectus,
            roleName
        } = this.props;
        return (
            <div>
                {trust.editTrustVisibility ? (
                    <EditTrust />
                ) : trust.viewTrustVisibility ? (
                    <ViewTrust />
                ) : portfolio.editPortfolioVisibility ? (
                    <EditPortfolio client={selectedClientOption} />
                ) : portfolio.viewPortfolioVisibility ? (
                    <ViewPortfolio client={selectedClientOption} />
                ) : classes.editClassVisibility ? (
                    <EditClass client={selectedClientOption} />
                ) : classes.viewClassVisibility ? (
                    <ViewClass client={selectedClientOption} />
                ) : prospectus.editProspectusVisibility ? (
                    <EditProspectus />
                ) : prospectus.viewProspectusVisibility ? (
                    <ViewProspectus />
                ) : (
                    <div>
                        <div className="row">
                            <div className="col-md-6 mb">
                                <Select
                                    name="clientSelect"
                                    placeholder="Choose a Client"
                                    valueKey="clientId"
                                    labelKey="name"
                                    selectedValue={selectedClientOption}
                                    onChange={this.handleClientChange}
                                    options={clientInformation.clients}
                                    disabled={roleName !== 'Administrator'}
                                />
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-md-6 mb">
                                <div
                                    role="tabpanel"
                                    className="panel"
                                    style={{ padding: 0, margin: 0 }}
                                >
                                    <Tabs
                                        id="tabID"
                                        activeKey={this.state.activeTabKey}
                                        onSelect={this.handleTabSelect}
                                    >
                                        <Tab eventKey={1} title="Trusts">
                                            <div className="mt-lg">
                                                {trustOptions.map(trust => {
                                                    const trustLabel = (
                                                        <span className="node">
                                                            <a
                                                                onClick={() =>
                                                                    this.handleCollapse(
                                                                        'trust',
                                                                        trust.trustId,
                                                                        this
                                                                            .state[
                                                                            trust
                                                                                .trustId
                                                                        ]
                                                                    )
                                                                }
                                                            >
                                                                {trust.name} (
                                                                {trust.edgarCik}
                                                                )
                                                            </a>{' '}
                                                            <a
                                                                onClick={() =>
                                                                    this.onEditClick(
                                                                        'trust',
                                                                        trust.trustId,
                                                                        undefined,
                                                                        false
                                                                    )
                                                                }
                                                            >
                                                                <Glyphicon glyph="eye-open" />
                                                            </a>{' '}
                                                            <a
                                                                onClick={() =>
                                                                    this.onEditClick(
                                                                        'trust',
                                                                        trust.trustId,
                                                                        undefined
                                                                    )
                                                                }
                                                            >
                                                                <Glyphicon glyph="edit" />
                                                            </a>
                                                        </span>
                                                    );
                                                    return (
                                                        <TreeView
                                                            key={trust.trustId}
                                                            nodeLabel={
                                                                trustLabel
                                                            }
                                                            collapsed={
                                                                this.state[
                                                                    trust
                                                                        .trustId
                                                                ]
                                                            }
                                                            onClick={() =>
                                                                this.handleCollapse(
                                                                    'trust',
                                                                    trust.trustId,
                                                                    this.state[
                                                                        trust
                                                                            .trustId
                                                                    ]
                                                                )
                                                            }
                                                            defaultCollapsed={
                                                                true
                                                            }
                                                        >
                                                            {trust.portfolios &&
                                                                trust.portfolios.map(
                                                                    portfolio => {
                                                                        const portfolioLabel = (
                                                                            <span className="node">
                                                                                <a
                                                                                    onClick={() =>
                                                                                        this.handleCollapse(
                                                                                            'portfolio',
                                                                                            trust.trustId +
                                                                                                '|' +
                                                                                                portfolio.portfolioId,
                                                                                            this
                                                                                                .state[
                                                                                                trust.trustId +
                                                                                                    '|' +
                                                                                                    portfolio.portfolioId
                                                                                            ]
                                                                                        )
                                                                                    }
                                                                                >
                                                                                    {
                                                                                        portfolio.name
                                                                                    }{' '}
                                                                                    (
                                                                                    {
                                                                                        portfolio.edgarSeriesId
                                                                                    }

                                                                                    )
                                                                                </a>{' '}
                                                                                <a
                                                                                    onClick={() =>
                                                                                        this.onEditClick(
                                                                                            'portfolio',
                                                                                            portfolio.portfolioId,
                                                                                            trustOptions,
                                                                                            false
                                                                                        )
                                                                                    }
                                                                                >
                                                                                    <Glyphicon glyph="eye-open" />
                                                                                </a>{' '}
                                                                                <a
                                                                                    onClick={() =>
                                                                                        this.onEditClick(
                                                                                            'portfolio',
                                                                                            portfolio.portfolioId,
                                                                                            trustOptions
                                                                                        )
                                                                                    }
                                                                                >
                                                                                    <Glyphicon glyph="edit" />
                                                                                </a>
                                                                            </span>
                                                                        );
                                                                        return (
                                                                            <TreeView
                                                                                key={
                                                                                    trust.trustId +
                                                                                    '|' +
                                                                                    portfolio.portfolioId
                                                                                }
                                                                                nodeLabel={
                                                                                    portfolioLabel
                                                                                }
                                                                                collapsed={
                                                                                    this
                                                                                        .state[
                                                                                        trust.trustId +
                                                                                            '|' +
                                                                                            portfolio.portfolioId
                                                                                    ]
                                                                                }
                                                                                onClick={() =>
                                                                                    this.handleCollapse(
                                                                                        'portfolio',
                                                                                        trust.trustId +
                                                                                            '|' +
                                                                                            portfolio.portfolioId,
                                                                                        this
                                                                                            .state[
                                                                                            trust.trustId +
                                                                                                '|' +
                                                                                                portfolio.portfolioId
                                                                                        ]
                                                                                    )
                                                                                }
                                                                                defaultCollapsed={
                                                                                    true
                                                                                }
                                                                            >
                                                                                {portfolio.classes &&
                                                                                    portfolio.classes.map(
                                                                                        classes => {
                                                                                            return (
                                                                                                <div className="tree-view_children">
                                                                                                    {
                                                                                                        classes.name
                                                                                                    }{' '}
                                                                                                    (
                                                                                                    {
                                                                                                        classes.cusip
                                                                                                    }{' '}
                                                                                                    -{' '}
                                                                                                    {
                                                                                                        classes.tickerSymbol
                                                                                                    }{' '}
                                                                                                    -{' '}
                                                                                                    {
                                                                                                        classes.clientCode
                                                                                                    }

                                                                                                    ){' '}
                                                                                                    <a
                                                                                                        onClick={() =>
                                                                                                            this.onEditClick(
                                                                                                                'class',
                                                                                                                classes.classId,
                                                                                                                trust.portfolios,
                                                                                                                false
                                                                                                            )
                                                                                                        }
                                                                                                    >
                                                                                                        <Glyphicon glyph="eye-open" />
                                                                                                    </a>{' '}
                                                                                                    <a
                                                                                                        onClick={() =>
                                                                                                            this.onEditClick(
                                                                                                                'class',
                                                                                                                classes.classId,
                                                                                                                trust.portfolios
                                                                                                            )
                                                                                                        }
                                                                                                    >
                                                                                                        <Glyphicon glyph="edit" />
                                                                                                    </a>
                                                                                                </div>
                                                                                            );
                                                                                        }
                                                                                    )}
                                                                            </TreeView>
                                                                        );
                                                                    }
                                                                )}
                                                        </TreeView>
                                                    );
                                                })}
                                            </div>
                                        </Tab>
                                        <Tab eventKey={2} title="Prospectus">
                                            {selectedClientOption &&
                                                prospectus.prospectusList && (
                                                    <ul className="mt-lg pl-sm">
                                                        {prospectus.prospectusList.map(
                                                            prospectus => {
                                                                return (
                                                                    <div className="tree-view_children">
                                                                        <li>
                                                                            <a
                                                                                onClick={() =>
                                                                                    this.onEditClick(
                                                                                        'prospectus',
                                                                                        prospectus.prospectusId,
                                                                                        null,
                                                                                        false
                                                                                    )
                                                                                }
                                                                            >
                                                                                {
                                                                                    prospectus.name
                                                                                }
                                                                            </a>{' '}
                                                                            <a
                                                                                onClick={() =>
                                                                                    this.onEditClick(
                                                                                        'prospectus',
                                                                                        prospectus.prospectusId,
                                                                                        null,
                                                                                        false
                                                                                    )
                                                                                }
                                                                            >
                                                                                <Glyphicon glyph="eye-open" />
                                                                            </a>{' '}
                                                                            <a
                                                                                onClick={() =>
                                                                                    this.onEditClick(
                                                                                        'prospectus',
                                                                                        prospectus.prospectusId
                                                                                    )
                                                                                }
                                                                            >
                                                                                <Glyphicon glyph="edit" />
                                                                            </a>
                                                                        </li>
                                                                    </div>
                                                                );
                                                            }
                                                        )}{' '}
                                                    </ul>
                                                )}
                                        </Tab>
                                    </Tabs>
                                </div>
                            </div>
                        </div>
                    </div>
                )}
                {(clientInformation.fetching ||
                    trust.fetching ||
                    prospectus.fetching) && <Spinner />}
            </div>
        );
    }
}

const mapStateToProps = state => ({
    clientInformation: state.employee.clientInformation,
    trust: state.employee.trust,
    portfolio: state.employee.portfolio,
    classes: state.employee.classes,
    prospectus: state.employee.prospectus,
    user: state.authentication.user,
    roleName: state.authentication.user
        ? state.authentication.user.roleName
        : ''
});

const mapDispatchToProps = dispatch =>
    bindActionCreators(
        {
            fetchAllClientInformationData,
            fetchClientInformationData,
            fetchTrustByClient,
            fetchPortfolioByTrust,
            fetchClassesByPortfolio,
            fetchTrustData,
            fetchTrustFilings,
            fetchTrustHistory,
            fetchPortfolioData,
            fetchPortfolioFilings,
            fetchPortfolioHistory,
            fetchClassData,
            fetchClassFilings,
            fetchClassHistory,
            fetchProspectusByClient,
            fetchProspectusData,
            fetchProspectusFilings,
            fetchProspectusHistory,
            handleEditTrustVisibility,
            handleViewTrustVisibility,
            handleEditPortfolioVisibility,
            handleViewPortfolioVisibility,
            handleEditClassVisibility,
            handleViewClassVisibility,
            handleEditProspectusVisibility,
            handleViewProspectusVisibility,
            clearTrustsList,
            clearProspectusesList,
            clearPortfoliosList,
            clearClassesList,
            fetchClassById,
            fetchPortfolioById
        },
        dispatch
    );
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withRouter(ClientDetails));



// WEBPACK FOOTER //
// ./src/screens/EmployeePanel/screens/ClientDetails/screens/index.js